<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deleteRegion" @cancel="cancel" />
    <types-modal
      :updateDialog="updateDialog"
      :eachBasicData="item"
      @closeUpdateDialog="closeUpdateDialog"
    />
    <v-data-table
      :headers="headers"
      :items="basicData"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar class="pt-1" flat>
          <v-toolbar-title>{{ typeInfo.name }}</v-toolbar-title>
          <v-divider class="mx-4 " inset vertical></v-divider>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>
            <div>
              <v-btn
                @click="openUpdateForm(item)"
                icon
                color="orange darken-1"
                class="mr-2 white--text"
                depressed
              >
                <v-icon>
                  mdi-pencil-outline
                </v-icon>
              </v-btn>
              <v-btn
                @click="openConfrimBox(item)"
                icon
                color="red lighten-1"
                class="white--text"
                depressed
              >
                <v-icon>
                  mdi-delete-outline
                </v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";
import TypesModal from "@/components/referral-types/TypesModal";

export default {
  props: {
    basicData: {
      type: Array,
    },
    typeInfo: {
      type: Object,
    },
  },
  components: {
    ConfirmBox,
    TypesModal,
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    updateDialog: false,
    headers: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" },
      { text: "Actions", value: "actions", align: "end" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    openConfrimBox(item) {
      //SET  TYPE FOR DELETE PROCESS
      this.item.id = item.id;
      this.item.type = this.typeInfo.type;
      this.dialog = !this.dialog;
    },
    openUpdateForm(item) {
      //SET  TYPE FOR UPDATE PROCESS
      this.item.name = item.name;
      this.item.id = item.id;
      this.item.type = this.typeInfo.type;
      this.updateDialog = !this.updateDialog;
    },
    closeUpdateDialog() {
      this.updateDialog = !this.updateDialog;
    },
    deleteRegion() {
      let data = {
        id: this.item.id,
        type: this.item.type,
      };
      this.$store
        .dispatch("InitialData/delete", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style scoped></style>
